import { platform } from 'constants'
import { IS_WEB } from 'constants/platform'
import { useTheme } from 'contexts'
import React, { useEffect, useRef } from 'react'
import { TextInput as RNTextInput, StyleSheet, View } from 'react-native'

type SearchBarProps = {
  searchTerm: string
  setSearchTerm: (value: string) => void
  setIsSearching: (value: boolean) => void
  placeholder?: string
  autoFocus?: boolean
  showConnectedSearchResults?: boolean
  shouldPadTop?: boolean
}

const webStyle = { outlineWidth: '0px' }

export const SearchBar = ({
  searchTerm,
  setSearchTerm,
  setIsSearching,
  placeholder,
  autoFocus = false,
  showConnectedSearchResults = false,
  shouldPadTop = false,
}: SearchBarProps): JSX.Element => {
  const theme = useTheme()
  const textInputRef = useRef<RNTextInput>()

  const handleFocus = () => {
    setIsSearching(true)
  }

  useEffect(() => {
    if (autoFocus && !textInputRef.current?.isFocused()) {
      if (!IS_WEB) {
        textInputRef.current?.focus()
      } else {
        setTimeout(() => textInputRef.current?.focus())
      }
    }
  })

  const computedStyles = StyleSheet.create({
    textInput: {
      borderBottomLeftRadius: showConnectedSearchResults ? 0 : undefined,
      borderBottomRightRadius: showConnectedSearchResults ? 0 : undefined,
      borderRadius: 10,
      backgroundColor: theme.colors.greyLight,
      padding: 10,
      ...(platform.IS_WEB && webStyle),
    },
    view: {
      borderRadius: 10,
      paddingTop: shouldPadTop ? theme.spacing.md : undefined,
    },
  })

  return (
    <View style={computedStyles.view}>
      <RNTextInput
        ref={textInputRef}
        autoFocus={autoFocus}
        onChangeText={setSearchTerm}
        onFocus={handleFocus}
        placeholder={placeholder}
        placeholderTextColor={theme.colors.greyDarker}
        value={searchTerm}
        numberOfLines={1}
        selectionColor={theme.colors.v2primary}
        style={computedStyles.textInput}
      />
    </View>
  )
}
